module.exports = __webpack_public_path__ + "img/icon_check_dark.54f944b0.svg";